<template>
    <div></div>
</template>

<script>
import { connectWebViewJavascriptBridge } from '@/utils/OverallJsMobile'
import Cookies from 'js-cookie'
import { Toast} from 'vant'
export default {
  /**
   * 分享页面 参数说明
   * share: {
   *    title 必传
   *    desc  必传
   *    url   必传
   *    imgUrl  必传
   * }
   *
   */
  name: 'wx-auth',
  props: ['share'],
  created () {
    this.wxAuth()
    let isNativeApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
    if (isNativeApp || (Cookies.get('homedo_port') && Cookies.get('homedo_port').toUpperCase() === 'APP')) {
      setTimeout(() => {
        this.nativeShare()
      }, 2000);
    }
  },
  methods: {
    wxAuth () {
      let self = this
      this.$store.dispatch('WX_GET_CONFIG', this.share.url).then(result => {
        if (result && result.data && result.data.code === 200) {
          let wxConfig = result.data.data
          this.$wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: wxConfig.appId, // 必填，公众号的唯一标识
            timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
            nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
            signature: wxConfig.signature, // 必填，签名
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表  分享给朋友 分享到QQ, 分享到朋友圈 分享到QQ空间
          })
          this.$wx.ready(() => {
            this.$wx.onMenuShareTimeline({
              title: self.share.title, // 分享标题
              link: wxConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: self.share.imgUrl, // 分享图标
              success: function () {
                if (self.share.callback) {
                  self.$emit(self.share.callback, {
                    type: 'success'
                  })
                }
              }
            })

            this.$wx.onMenuShareAppMessage({
              title: self.share.title, // 分享标题
              desc: self.share.desc, // 分享描述
              link: wxConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: self.share.imgUrl, // 分享图标
              success: function () {
                if (self.share.callback) {
                  self.$emit(self.share.callback, {
                    type: 'success'
                  })
                }
              },
              trigger: function (event) {
                if ((event.shareTo === 'friend' || event.scene === 'friend') && self.share.callback) {
                  // 点击分享朋友
                  self.$emit(self.share.callback, {
                    type: 'success'
                  })
                }
              }
            })
            /* 分享给朋友 */
            /* this.$wx.updateAppMessageShareData({
              title: self.share.title, // 分享标题
              desc: self.share.desc, // 分享描述
              link: wxConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: self.share.imgUrl // 分享图标
            }) */
            /* 分享到朋友圈 */
            /* this.$wx.updateTimelineShareData({
              title: self.share.title, // 分享标题
              link: wxConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: self.share.imgUrl // 分享图标
            }) */
          })
          this.$wx.error(error => {
            console.log('微信分享config注册异常：' + JSON.stringify(error))
          })
        }
      })
    },
    // 原生APP 调用分享
    nativeShare () {
      let _this = this
      connectWebViewJavascriptBridge(function (bridge) {
        bridge.registerHandler('callHDBridgeHandler', function (message, responseCallback) {
          let jsonMessage = JSON.parse(message)
          // Toast(`收到消息：${jsonMessage}`)
          if (typeof (jsonMessage.name) !== 'undefined' && jsonMessage.name === 'requestShare') {
            let data = {
              'name': 'activityshare',
              'value': _this.share.url,
              'title': _this.share.title,
              'count': '',
              'type': '',
              'promtion': '',
              'dict': JSON.stringify({
                Subtitle: _this.share.title,
                shareImg: _this.share.imgUrl,
                activityName: _this.share.title,
                activityId: 0
              })
            }
            // 调用原生方法
            bridge.callHandler('registerHDBridgeHandler', data, function (response) {
              // Toast(`发送消息：${data}`)
              // Toast(`接到${response}`)
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wxAuth.vue